import { IRootState } from '../../../store'
import { IAddMedicationAdministeredOptionsState } from '../store/options.types'

export const getAddMedicationAdministeredOptionsSelector = (
  state: IRootState
): IAddMedicationAdministeredOptionsState => state.options.addMedicationAdministeredOptions
